// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1xp2F","label":"Category_label__2nqK0","content":"Category_content__1pFGc","header":"Category_header__rFCvM","location":"Category_location__2RLkU"};